import * as React from 'react';
import { Dispatch, AnyAction } from 'redux';

import { AppFormOwnProps } from '../components/form/appForm';
import { InternalActionTypes } from '../constants/actionTypes';

import { RequestAction } from './allActions';

export interface FormSubmitAction<T> extends RequestAction {
  formData: T;
}

export interface UpdateFormDataAction extends AnyAction {
  type: InternalActionTypes.UpdateFormData;
  formData: any;
  formId: string;
}
export function createUpdateFormDataAction(formId: string, formData: any): UpdateFormDataAction {
  return {
    formData,
    formId,
    type: InternalActionTypes.UpdateFormData,
  };
}
export function createFormSubmitAction<T>(
  formData: T,
  form: React.Component,
  dispatch: Dispatch,
  props: AppFormOwnProps<T>,
): FormSubmitAction<T> {
  return {
    ...props.reduxData,
    dispatch,
    formData,
    requestingComponent: form,
    type: props.submitActionType,
  };
}
